/**
 * @file utils/fileUtil.js 文件相关功能
 * @author zhangzhe(zhangzhe@baidu.com)
 */
import humanize from 'humanize';

export interface FilesizeOpts {
    kilo?: number, // 量级（默认是1024）
    decimals?: number, // 小数位数
    decPoint?: string; // 小数点
    thousandsSep?: string, // 千位分割符
    suffixSep?: string // 后缀分割符
}

export function filesize(size: any, options?: FilesizeOpts): string {
    if (options) {
        const {kilo, decimals, decPoint, thousandsSep, suffixSep} = options;
        return humanize.filesize(size, kilo, decimals, decPoint, thousandsSep, suffixSep);
    }
    return humanize.filesize(size);
}

export function getSuffixByName(name: string): string {
    return name.slice(name.lastIndexOf('.') + 1);
}
